module.exports = __webpack_public_path__ + "media/configurations/ZOC_P-X-X-X-X-P-d2e91568.png";